<template>
  <v-row class="maxheight px-3 mt-1">
    <v-col class="pa-0 maxheight">
      <v-list dense class="py-0">
        <RouteListItem v-for="item in menuTree" :key="item.name" :node="item">
        </RouteListItem>
        <!-- list item bellow is a spacer dont remove -->
        <v-list-item class="spacerli" />
      </v-list>
    </v-col>
  </v-row>
</template>


<script>
import NavMixin from "@/helpers/Mixins/NavMixin.js";
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";

export default {
  components: {
    RouteListItem,
  },
  mixins: [NavMixin],

  data() {
    return {
      menuTree: this.$router.options.routes,
    };
  },

  mounted() {
  },

  methods: {
  },

  computed: {

  },

  watch: {

  },
};
</script>



<style lang="scss">
.toplited {
  z-index: 100;
}

.maxheightconatiner {
  height: calc(100vh - 30px) !important;
}

.maxheight {
  max-height: 100%;
  overflow: overlay;
  /*border-top: 1px solid rgb(238, 238, 238);*/
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .maxheight {
    overflow: auto;
  }
}

.minheight {
  min-height: 100%;
}

.forward {
  position: relative;
  z-index: 20;
  margin-left: -1px;
}

div::-webkit-scrollbar {
  width: 11px;
}

div::-webkit-scrollbar-track {
  /*background: #e6e6e6;
  border-left: 1px solid #dadada;*/
}

div::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 3px #e9e9e9;
  border-radius: 7px;
}

div::-webkit-scrollbar-thumb:hover {
  background: rgb(121, 121, 121);
}

.closertop {
  margin-top: -4px;
  margin-bottom: 4px;
}

.logobackground {
  flex-grow: 0;
}

.spacerli {
  min-height: 20px !important;
  max-height: 20px !important;
}
</style>
